<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,14C14,14,2,14,2,14C2,14,2,2,2,2C2,2,10.76,2,10.76,2C10.76,2,12.76,0,12.76,0C12.76,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,6.24,16,6.24C16,6.24,14,8.24,14,8.24C14,8.24,14,14,14,14C14,14,14,14,14,14ZM15.4,0C15.4,0,9.7,5.7,9.7,5.7C9.7,5.7,11.8,7.8,11.8,7.8C11.8,7.8,16,3.6,16,3.6C16,3.6,16,0,16,0C16,0,15.4,0,15.4,0C15.4,0,15.4,0,15.4,0ZM4,11.92C6.33,12.07,8.42,12.07,10.15,10.42C10.97,9.59,10.97,8.17,10.15,7.34C9.7,6.96,9.17,6.74,8.65,6.74C8.12,6.74,7.6,6.96,7.22,7.34C6.4,8.25,5.95,10.72,4,11.92C4,11.92,4,11.92,4,11.92Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Style',
} as DefineComponent
</script>
